import {
  FloatingContext,
  FloatingFocusManager,
  FloatingNode,
  FloatingPortal,
  ReferenceType,
  useTransitionStyles,
} from '@floating-ui/react'
import React from 'react'

import styles from './Popup.module.scss'

interface PopupProps extends React.HTMLAttributes<HTMLDivElement> {
  nodeId: string
  opened: boolean
  context: FloatingContext<ReferenceType>
  initialFocus?: React.MutableRefObject<HTMLElement>
  returnFocus?: boolean
  disabled?: boolean
}

function Popup(
  {
    children,
    className,
    opened,
    nodeId,
    context,
    returnFocus,
    disabled,
    initialFocus,
    ...props
  }: React.PropsWithChildren<PopupProps>,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { isMounted, styles: transitionStyles } = useTransitionStyles(context)

  return (
    <FloatingNode id={nodeId}>
      {opened && isMounted && (
        <FloatingPortal>
          <FloatingFocusManager
            context={context}
            initialFocus={initialFocus}
            returnFocus={returnFocus}
            disabled={disabled}
            modal={false}
          >
            <div ref={ref} className={styles.root} {...props}>
              <div style={transitionStyles} className={className}>
                {children}
              </div>
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      )}
    </FloatingNode>
  )
}

export default React.forwardRef<HTMLDivElement, PopupProps>(Popup)
